<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card height="100%">
      <v-card-title class="primary white--text text-uppercase">
        Báo cáo học tập
        <v-spacer></v-spacer>
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-tabs v-model="activeTab">
        <v-tab>Điểm danh</v-tab>
        <!-- <v-tab>Điểm số</v-tab> -->
        <v-tab>Đánh giá</v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab" class="flex-grow-1 pa-3">
        <v-tab-item>
          <attendance-tab :item="selectedItem" />
        </v-tab-item>
        <!-- <v-tab-item>
          <score-tab :item="selectedItem" />
        </v-tab-item> -->
        <v-tab-item>
          <evaluate-tab :item="selectedItem" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import AttendanceTab from './AttendanceTab.vue'
// import ScoreTab from './ScoreTab.vue'
import EvaluateTab from './EvaluateTab.vue'

export default {
  components: {
    AttendanceTab,
    // ScoreTab,
    EvaluateTab,
  },
  props: {},
  data() {
    return {
      dialog: false,
      activeTab: 0,
      selectedItem: null,
    }
  },
  methods: {
    async openDialog(item) {
      this.dialog = true
      this.selectedItem = item
    },
    cancel() {
      this.dialog = false
    },
  },
}
</script>
